import type { ButtonHTMLAttributes, ReactNode } from 'react';

/** danger は取り消せない操作（削除）専用。主操作の青と取り違えないよう赤系にする。 */
export type ButtonVariant = 'primary' | 'default' | 'text' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  children: ReactNode;
}

/**
 * モックにはprimaryが黒(#252b32)と青(#377fc0)の2系統あったが、
 * 初期実装の画面はすべて管理ページなのでWorkspace側の青（--accent）1系統へ統一した。
 * 黒primaryはAI対話デモ側の見た目で、初期スコープにその画面がないため採用しない。
 *
 * typeの既定をbuttonにしているのは、Workspace作成などのform内で
 * 補助ボタンが意図せずsubmitするのを防ぐため。
 */
export function Button({ variant = 'default', className, type = 'button', ...rest }: ButtonProps) {
  const classes = ['button'];
  if (variant === 'primary') classes.push('button-primary');
  if (variant === 'text') classes.push('button-text');
  if (variant === 'danger') classes.push('button-danger');
  if (className !== undefined) classes.push(className);
  return <button {...rest} type={type} className={classes.join(' ')} />;
}
